import React from 'react';
export const CheckmarkIcon = ({
  className = '',
  color = 'currentColor',
  size = 24
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-118">
    <path d="M20 6L9 17L4 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-119" />
  </svg>;
export const DiamondIcon = ({
  className = '',
  color = 'currentColor',
  size = 24
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-120">
    <path d="M12 2L22 12L12 22L2 12L12 2Z" fill={color} data-id="element-121" />
  </svg>;
export const StarIcon = ({
  className = '',
  color = 'currentColor',
  size = 24
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-122">
    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" data-id="element-123" />
  </svg>;
export const QuoteMarkIcon = ({
  className = '',
  color = 'currentColor',
  size = 48
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-124">
    <path d="M10 11H6C6 8.79 7.79 7 10 7V5C6.69 5 4 7.69 4 11V19H10V11ZM20 11H16C16 8.79 17.79 7 20 7V5C16.69 5 14 7.69 14 11V19H20V11Z" data-id="element-125" />
  </svg>;
export const ShieldIcon = ({
  className = '',
  color = 'currentColor',
  size = 72
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-126">
    <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-127" />
    <path d="M9 12L11 14L15 10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-128" />
  </svg>;
export const LockIcon = ({
  className = '',
  color = 'currentColor',
  size = 24
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-129">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-130" />
    <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-131" />
  </svg>;
export const DownloadIcon = ({
  className = '',
  color = 'currentColor',
  size = 24
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-132">
    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-133" />
    <path d="M7 10L12 15L17 10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-134" />
    <path d="M12 15V3" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-135" />
  </svg>;
export const CalendarIcon = ({
  className = '',
  color = 'currentColor',
  size = 24
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-136">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-137" />
    <path d="M16 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-138" />
    <path d="M8 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-139" />
    <path d="M3 10H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-140" />
  </svg>;
export const ClockIcon = ({
  className = '',
  color = 'currentColor',
  size = 32
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-141">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-142" />
    <path d="M12 6V12L16 14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-143" />
  </svg>;
export const ChevronArrowIcon = ({
  className = '',
  color = 'currentColor',
  size = 24
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-144">
    <path d="M6 9L12 15L18 9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-145" />
  </svg>;
export const FemaleAvatarIcon = ({
  className = '',
  color = 'currentColor',
  size = 36
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-146">
    <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" data-id="element-147" />
  </svg>;
export const CircleCheckIcon = ({
  className = '',
  color = 'currentColor',
  size = 16
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-148">
    <circle cx="12" cy="12" r="10" fill={color} data-id="element-149" />
    <path d="M8 12.5L11 15.5L16.5 9.5" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" data-id="element-150" />
  </svg>;
export const DiamondBulletIcon = ({
  className = '',
  color = 'currentColor',
  size = 8
}) => <svg width={size} height={size} viewBox="0 0 8 8" fill={color} xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-151">
    <path d="M4 0L8 4L4 8L0 4L4 0Z" data-id="element-152" />
  </svg>;